import { render, staticRenderFns } from "./CardEvent.vue?vue&type=template&id=89685876&scoped=true"
import script from "./CardEvent.vue?vue&type=script&lang=js"
export * from "./CardEvent.vue?vue&type=script&lang=js"
import style0 from "./CardEvent.vue?vue&type=style&index=0&id=89685876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89685876",
  null
  
)

export default component.exports